import React from 'react';

interface Props {
	children: React.ReactNode;
	style?: object;
}

const FormCard: React.FC<Props> = ({ children, style }) => {
	return (
		<div className='form-card' style={style}>
			{children}
		</div>
	);
};

export default FormCard;
